import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { EventEmitter } from 'events';
export var LogProvider =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(LogProvider, _EventEmitter);

  function LogProvider() {
    var _this;

    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

    _classCallCheck(this, LogProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LogProvider).call(this));

    _defineProperty(_assertThisInitialized(_this), "cachedSettings", null);

    _defineProperty(_assertThisInitialized(_this), "fromFile", false);

    _defineProperty(_assertThisInitialized(_this), "cachedEntries", []);

    _defineProperty(_assertThisInitialized(_this), "hasMore", true);

    _defineProperty(_assertThisInitialized(_this), "poll", false);

    _defineProperty(_assertThisInitialized(_this), "pollActive", false);

    _this.baseLimit = limit;
    _this.loading = false;
    _this.limit = limit;
    _this.searchQuery = '';
    return _this;
  }

  _createClass(LogProvider, [{
    key: "reset",
    value: function reset() {
      this.hasMore = true;
      this.limit = this.baseLimit;
      this.cachedEntries = [];
      this.loading = false;
    }
  }, {
    key: "load",
    value: function load() {
      var newData;
      return _regeneratorRuntime.async(function load$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;

              if (!(this.cachedEntries.length >= this.limit || this.fromFile || !this.hasMore)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return _regeneratorRuntime.awrap(this.loadEntries(this.cachedEntries.length, this.limit - this.cachedEntries.length));

            case 5:
              newData = _context.sent;

              if (newData.data.length === 0) {
                this.hasMore = false;
              }

              this.cachedEntries = this.cachedEntries.concat(newData.data);
              this.loading = false;
              this.emit('entries', this.cachedEntries);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "loadEntries",
    value: function loadEntries(offset) {
      var _this2 = this;

      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      return this.getSettings().then(function (_ref) {
        var levels = _ref.levels;

        if (_this2.searchQuery) {
          return $.get(OC.generateUrl('/apps/logreader/search'), {
            offset: offset,
            count: count,
            query: _this2.query,
            levels: levels
          });
        } else {
          return $.get(OC.generateUrl('/apps/logreader/get'), {
            offset: offset,
            count: count,
            levels: levels
          });
        }
      });
    }
  }, {
    key: "getSettings",
    value: function getSettings() {
      return _regeneratorRuntime.async(function getSettings$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.cachedSettings) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", this.cachedSettings);

            case 2:
              _context2.next = 4;
              return _regeneratorRuntime.awrap($.get(OC.generateUrl('/apps/logreader/settings')));

            case 4:
              this.cachedSettings = _context2.sent;
              return _context2.abrupt("return", this.cachedSettings);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getLevels",
    value: function getLevels() {
      var _ref2, levels;

      return _regeneratorRuntime.async(function getLevels$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _regeneratorRuntime.awrap(this.getSettings());

            case 2:
              _ref2 = _context3.sent;
              levels = _ref2.levels;
              return _context3.abrupt("return", levels.split('').map(function (level) {
                return level > 0;
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "setLevels",
    value: function setLevels(levels) {
      var levelsString = levels.map(function (level) {
        return level ? 1 : 0;
      }).join('');

      if (this.cachedSettings) {
        this.cachedSettings.levels = levelsString;
      }

      return $.ajax({
        type: 'PUT',
        url: OC.generateUrl('/apps/logreader/levels'),
        data: {
          levels: levelsString
        }
      });
    }
  }, {
    key: "getRelative",
    value: function getRelative() {
      var _ref3, relativedates;

      return _regeneratorRuntime.async(function getRelative$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _regeneratorRuntime.awrap(this.getSettings());

            case 2:
              _ref3 = _context4.sent;
              relativedates = _ref3.relativedates;
              return _context4.abrupt("return", relativedates);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getDateFormat",
    value: function getDateFormat() {
      var _ref4, dateformat;

      return _regeneratorRuntime.async(function getDateFormat$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _regeneratorRuntime.awrap(this.getSettings());

            case 2:
              _ref4 = _context5.sent;
              dateformat = _ref4.dateformat;
              return _context5.abrupt("return", dateformat);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getLive",
    value: function getLive() {
      var _ref5, live;

      return _regeneratorRuntime.async(function getLive$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _regeneratorRuntime.awrap(this.getSettings());

            case 2:
              _ref5 = _context6.sent;
              live = _ref5.live;
              return _context6.abrupt("return", live);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "setRelative",
    value: function setRelative(relative) {
      return $.ajax({
        type: 'PUT',
        url: OC.generateUrl('/apps/logreader/relative'),
        data: {
          relative: relative
        }
      });
    }
  }, {
    key: "setLive",
    value: function setLive(live) {
      return $.ajax({
        type: 'PUT',
        url: OC.generateUrl('/apps/logreader/live'),
        data: {
          live: live
        }
      });
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var lastReqId, newData;
      return _regeneratorRuntime.async(function startPolling$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(this.cachedEntries.length === 0 || this.poll || this.pollActive)) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              this.pollActive = true;
              this.poll = true;

            case 4:
              if (!this.poll) {
                _context7.next = 12;
                break;
              }

              lastReqId = this.cachedEntries[0].reqId;
              _context7.next = 8;
              return _regeneratorRuntime.awrap($.get(OC.generateUrl('/apps/logreader/poll'), {
                lastReqId: lastReqId
              }));

            case 8:
              newData = _context7.sent;

              if (this.poll) {
                this.cachedEntries = newData.concat(this.cachedEntries);
                this.emit('entries', this.cachedEntries);
              }

              _context7.next = 4;
              break;

            case 12:
              this.pollActive = false;

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.poll = false;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "entries",
    get: function get() {
      return cachedEntries;
    }
  }, {
    key: "query",
    set: function set(newQuery) {
      var _this3 = this;

      if (newQuery !== this.searchQuery) {
        if (newQuery) {
          this.stopPolling();
        }

        this.searchQuery = newQuery;
        this.reset();
        this.load().then(function _callee() {
          return _regeneratorRuntime.async(function _callee$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.t0 = !newQuery;

                  if (!_context8.t0) {
                    _context8.next = 5;
                    break;
                  }

                  _context8.next = 4;
                  return _regeneratorRuntime.awrap(_this3.getLive());

                case 4:
                  _context8.t0 = _context8.sent;

                case 5:
                  if (!_context8.t0) {
                    _context8.next = 7;
                    break;
                  }

                  _this3.startPolling();

                case 7:
                case "end":
                  return _context8.stop();
              }
            }
          });
        });
      }
    },
    get: function get() {
      return this.searchQuery;
    }
  }]);

  return LogProvider;
}(EventEmitter);

_defineProperty(LogProvider, "levels", ['Debug', 'Info', 'Warning', 'Error', 'Fatal']);

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogProvider, "LogProvider", "/srv/http/owncloud/apps/logreader/js/Providers/LogProvider.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();